// Project specific values for the production environment
const config = {
  appId: '1:929467204332:web:2a34a212e8d986600b9bc9',
  apiKey: 'AIzaSyDPhwf9tMorK0Z-1tSaplPNe2nxmfK_1T8',
  authDomain: 'lcpro-9cc17.firebaseapp.com',
  databaseURL: 'https://lcpro-9cc17.firebaseio.com',
  projectId: 'lcpro-9cc17',
  storageBucket: 'lcpro-9cc17.appspot.com',
  messagingSenderId: '929467204332',
  measurementId: 'G-N5P0FXQE0R',
  hotjarId: 2380531
};

config.firestore = {
  // Use custom Firestore host
  host: 'f.liveshopping.bambuser.com',
};

// Where does the player reside? Used when dashboards produces player urls.
config.publicBaseUrl = process.env.WEBPLAYER_BASE_URL || 'https://lcx-player.bambuser.com';

// Where does the watch page reside? Deep-linked timestamped video views
// (e.g. product intelligence atom provenance) build URLs from this base.
config.watchBaseUrl = process.env.WATCH_BASE_URL || 'https://svc-prod-us.liveshopping.bambuser.com/watch';

// Where does the embed reside?
config.embedBaseUrl = process.env.EMBED_BASE_URL || 'https://lcx-embed.bambuser.com';

// Where does the widgets reside?
config.widgetsBaseUrl = process.env.WIDGETS_BASE_URL || 'https://lcx-widgets.bambuser.com';

// Where does the app framework reside?
config.appFrameworkBaseUrl = process.env.APP_FRAMEWORK_BASE_URL || 'https://app-framework.bambuser.com';

// Base url for event stream REST API
config.eventStreamBaseUrl = 'https://svc-prod-us.liveshopping.bambuser.com/eventstream';

// Base url for metrics REST API
config.metricsBaseUrl = 'https://svc-prod-us.liveshopping.bambuser.com/collect';

// Base url for client API
config.clientAPIBaseUrl = process.env.API_BASE_URL || 'https://svc-prod-us.liveshopping.bambuser.com/functions/api';

// Base url for the MCP server (hosts the OAuth endpoints behind /mcp-connect)
config.mcpBaseUrl = process.env.MCP_BASE_URL || 'https://mcp-prod-us.liveshopping.bambuser.com';

// Base url for social media API
config.socialMediaBaseUrl = process.env.SOCIAL_MEDIA_BASE_URL || 'https://svc-prod-us.liveshopping.bambuser.com/functions/socialMedia';

// Base url for Shopify App
config.shopifyBaseUrl = 'https://svc-prod-us.liveshopping.bambuser.com/functions/shopify';

// Base url for the show search API
config.showSearchUrl = process.env.SHOW_SEARCH_BASE_URL || 'https://svc-prod-us.liveshopping.bambuser.com/functions/showSearch';

// Base url for BigQuery stats API
config.bqStatsBaseUrl = process.env.BQSTATS_BASE_URL || `https://us-central1-${encodeURIComponent(config.projectId)}.cloudfunctions.net/statsLegacy`; // Explicit cloud function url to work around 1min timout on AWS CloudFront

// Base url for requests that can take minutes, such as generating a call insight. This is
// the cloud function url, past the 1 minute timeout on AWS CloudFront.
config.longRunningBaseUrl = process.env.LONG_RUNNING_BASE_URL || `https://us-central1-${encodeURIComponent(config.projectId)}.cloudfunctions.net/longRunning`;

// Base url for client product config
config.clientProductConfigBaseUrl = 'https://svc-prod-us.liveshopping.bambuser.com/functions/productConfig';

// Base url for client Auth
config.clientAuthBaseUrl = process.env.AUTH_BASE_URL || 'https://svc-prod-us.liveshopping.bambuser.com/functions/auth';
// Base url for embed.js inventory res
config.inventoryAPIBaseUrl = 'https://svc-prod-us.liveshopping.bambuser.com/functions/products';

// Base url for asset proxy (used when surfing in a srcdoc iframe with minimized player)
config.assetProxyBaseUrl = 'https://svc-prod-us.liveshopping.bambuser.com/functions/assetProxy'

// Base url for widgets client API
config.widgetsAPIBaseUrl = 'https://svc-prod-us.liveshopping.bambuser.com/functions/widgets';

// Base url for App Engine widgets client API
config.widgetsAppEngineAPIBaseUrl = 'https://svc-prod-us.liveshopping.bambuser.com/widgets';

// Base url for vod
config.vodUrl = process.env.VOD_BACKEND_BASE_URL || 'https://vod-j3dgogrltq-uc.a.run.app';

// Optional custom domain used when rendering shareable campaign-link URLs
// (e.g. https://shop.bmb.sr/l/<id>). Empty falls back to vodUrl.
config.linkShareBaseUrl = process.env.LINK_SHARE_BASE_URL || 'https://shop.bmb.sr/u1';

// Base url for product catalogue
config.productCatalogueServerUrl = process.env.PRODUCT_CATALOG_SERVER_BACKEND_BASE_URL || 'https://svc-prod-us.liveshopping.bambuser.com/product-catalog';

// Base url for videoeditor-cloudrun
config.videoEditorCloudRunBaseUrl = process.env.VIDEOEDITOR_CLOUDRUN_BASE_URL || 'https://videoeditor-cloudrun-j3dgogrltq-uc.a.run.app';

// Return url for redirecting back to the dashboard, for example after
// email verification and sso logout
config.returnUrl = process.env.HOSTING_DASHBOARDURL || 'https://lcx.bambuser.com';

// Pendo API key
config.pendoApiKey = '1f95d5c1-e361-4be8-bf0f-fa41605b7ea6';

// GTM tag id
config.gtmTagId = 'GTM-PNMBSTP';

// Public stripe key for billing page
config.stripePublicKey = 'pk_live_51IbKuwHvV77QG0tGZ76Vs6kbXWXdbHOh2gsjj6CfL6c509RhIzXbvuwRD2MGInZPN8QCouZa3BwCsNDqhI121stT003bh71P52';

config.facebook = {
  instagramConfigurationId: '354518663590925'
};

// Analytics' GCP-project
config.bigQueryProjectId = 'bambuser-analytics';

// Base url to image transformer service
config.imageTransformerBaseUrl = 'https://cdn.liveshopping.bambuser.com/imageTransformer';

// Base url for client API served via CF
config.clientAPIBaseCloudFrontUrl = 'https://cdn.liveshopping.bambuser.com/api';


// Base url for assets served via CF (fonts, images for customizations etc)
config.assetsCdnUrl = 'https://cdn.liveshopping.bambuser.com';

// Base url for Bambuser public REST API
config.lvsPublicAPIBaseUrl = 'https://liveshopping-api.bambuser.com';

// Base url for One-to-One embed and callWidget
config.callsEmbedUrl = 'https://one-to-one.bambuser.com/embed.js';
config.callsWidgetUrl = 'https://one-to-one.bambuser.com/refresh-us/call-widget';

config.transcriberUrl = 'https://transcribe.bambuser.com';

// Base url for chat parts
config.chatDashboardBaseUrl = process.env.CHAT_DASHBOARD_BASE_URL || 'https://us.dashboard.chat.bambuser.com';
config.chatWebAppBaseUrl = process.env.CHAT_WEB_APP_BASE_URL || 'https://us.online-only.chat.bambuser.com';
config.chatApiBaseUrl = process.env.CHAT_API_BASE_URL || 'https://api.chat.bambuser.com';

// Salesforce enterprise chat config
config.scriptSrc = 'https://bambuser.my.site.com/ESWSupportChat1764260269182/assets/js/bootstrap.min.js';
config.orgId = '00DJ6000000H05d';
config.siteUrl = 'https://bambuser.my.site.com/ESWSupportChat1764260269182';
config.scrt2Url = 'https://bambuser.my.salesforce-scrt.com';

module.exports = config;
